import axios from 'axios'

interface IResendMfaParams {
  challengeToken: string
}

const resendMfa = async ({ challengeToken }: IResendMfaParams) => {
  const apiUrl = `${process.env.REACT_APP_MAIN_API}/auth/login/resend-mfa`

  const response = await axios.post(
    apiUrl,
    {
      challenge_token: challengeToken,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

  return response
}

export default resendMfa
